import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

export const PrintedBox = styled(Box)(() => ({
  '@media print': {
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  width: '100%',
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.fixed.black}`
}));
